const randomIntFromInterval = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};

function emptyAvatarUploadField() {
    const file = document.querySelector<HTMLFormElement>("#file");
    if (file) {
        file.value = "";
    }
    const avatar = document.querySelector<HTMLFormElement>("#own-avatar");
    if (avatar) {
        avatar.innerHTML = "";
    }
}

const addEventTriggerAvatarRemove = () => {
    emptyAvatarUploadField();

    const avatarElement = document.querySelector<HTMLInputElement>(
        `#list-id-${randomIntFromInterval(1, 27)}`,
    );
    if (avatarElement) {
        avatarElement.checked = true;
        avatarElement.click();
    }
    const eventChange = new Event("change");
    if (avatarElement) {
        avatarElement.dispatchEvent(eventChange);
    }
};

const replaceAvatar = (
    radios: NodeListOf<HTMLElement>,
    dialogContent: HTMLDialogElement,
) => {
    const previewPlaces: NodeList = document.querySelectorAll(
        ".avatar-preview",
    ) as NodeList;
    const url: string = window.location.origin as string;

    for (let i: number = 0; i < radios.length; i++) {
        const $avatarId = i + 1;
        radios[i].addEventListener("click", () => {
            fetch(`${url}/media/avatar/${$avatarId}.svg`)
                .then((response: Response) => response.text())
                .then((svg: string) => {
                    emptyAvatarUploadField();
                    previewPlaces.forEach((previewPlace) => {
                        const placeToSwitchSvg: HTMLElement =
                            previewPlace as HTMLElement;
                        placeToSwitchSvg.innerHTML = "";
                        placeToSwitchSvg.insertAdjacentHTML("afterbegin", svg);
                        if (dialogContent) {
                            dialogContent.close();
                        }
                    });
                });
        });
    }
};

const replaceImg = (inputField: HTMLInputElement) => {
    // ersetze das selbst hoch geladene Bild
    const url = inputField.value;
    const ext = url.substring(url.lastIndexOf(".") + 1).toLowerCase();
    const removeOwnAvatar = document.querySelector(".delete-own-avatar");

    const previewPlaces =
        document.querySelectorAll<HTMLElement>(".avatar-preview");
    const dialogContent =
        document.querySelector<HTMLDialogElement>(".dialog-overview");
    const ownAvatar = document.getElementById("own-avatar");

    if (
        inputField.files &&
        inputField.files.length > 0 &&
        (ext === "jpeg" ||
            ext === "jpg" ||
            ext === "JPEG" ||
            ext === "JPG" ||
            ext === "png" ||
            ext === "PNG")
    ) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const image = `<img src="${e.target?.result}">`;
            previewPlaces.forEach((previewPlace) => {
                previewPlace.innerHTML = image;
                if (dialogContent) {
                    dialogContent.close();
                }
            });

            if (removeOwnAvatar) {
                removeOwnAvatar.classList.remove("disabled");
            }
            if (ownAvatar) {
                ownAvatar.innerHTML = image;
            }
        };
        reader.readAsDataURL(inputField.files[0]);
        const radios = document.querySelectorAll<HTMLFormElement>(
            '[name="avatar-select"]',
        );
        if (radios) {
            radios.forEach((radio) => {
                radio.checked = false;
            });
        }
    }
};

const submit = (form: HTMLFormElement) => {
    if (form.nodeName === "FORM") {
        form.submit();
    }
    return;
};

export const avatar = () => {
    const form = document.querySelector<HTMLFormElement>(".avatar-select-form");
    const dialogContent =
        document.querySelector<HTMLDialogElement>(".dialog-overview");

    if (!form) {
        return;
    }

    const fileUploadField =
        form.querySelector<HTMLInputElement>('[type="file"]');
    if (fileUploadField) {
        fileUploadField.addEventListener("change", () => {
            if (dialogContent) {
                dialogContent.close();
            }
            // Wird nur noch in der Registrierung (step 3) benoetigt
            replaceImg(fileUploadField);
            submit(form);
        });
    }

    // wenn du ein festes avatar (svg) auswaehlst:
    const radios = document.getElementsByName("avatar-select");
    if (radios.length > 0) {
        radios.forEach((radio: HTMLElement) => {
            radio.addEventListener("click", () => {
                submit(form);
            });
        });

        // Ersetze das Avatar logisch mit dem jeweils ausgewaehlten svg
        // Wird nur noch in der Registrierung (step 3) benoetigt
        if (dialogContent) {
            replaceAvatar(radios, dialogContent);
        }
    }

    // open file upload input, when clicking on new-own-avatar (linker bereich innerhalb von dem dialog)
    const newAvatar = form.querySelector<HTMLElement>(".new-own-avatar");
    if (newAvatar) {
        newAvatar.addEventListener("click", () => {
            const inputField = form.querySelector<HTMLElement>('[name="file"]');
            if (inputField) {
                inputField.click();
            }
        });
    }

    // remove own-avatar (rechter bereich innerhalb von dem dialog)
    const deleteOwnAvatar =
        form.querySelector<HTMLElement>(".delete-own-avatar");
    if (deleteOwnAvatar) {
        deleteOwnAvatar.addEventListener("click", () => {
            addEventTriggerAvatarRemove();
            if (dialogContent) {
                dialogContent.close();
            }
            submit(form);
        });
    }
};
